import React, { Component } from 'react'
import { browserHistory } from 'react-router'
import Helmet from 'react-helmet'
import PropTypes from 'prop-types'
import Img from 'gatsby-image'
import Link from 'gatsby-link'
import segmentLogo from '../assets/logos/Segment_logo.png'
import zapierLogo from '../assets/logos/zapier_logo.png'
import { OutboundLink } from 'gatsby-plugin-google-analytics'
import {
  Card,
  Icon,
  Image,
  Button,
  Label,
  List,
  Divider,
  Grid,
  Header,
  Statistic,
  Segment,
  Tab,
  Breadcrumb,
  Modal,
} from 'semantic-ui-react'

class ProductPage extends Component {
  render() {
    const {
      name,
      id,
      website,
      primaryCategories,
      subCategories,
      growthLever,
      screenshots,
      shortDescription,
      freeTrialAvailable,
      freePlan,
      startingPrice,
      pricingNote,
      createdAt,
      updatedAt,
      ourView,
      integratesWith,
      integratesWithSegment,
      integratesWithZapier,
      exampleUsecase,
      customersList,
      facebookLink,
      twitterLink,
      productHuntLink,
      youtubeLink,
      setupNotes,
      developerRequired,
      apiAvailable,
      keyFeatures,
      customerSector,
      customerBudget,
    } = this.props.data.contentfulProduct

    return (
      <div style={{ maxWidth: 1250, margin: '0 auto' }}>
        <Helmet>
          <title>
            {name}: Compare Features, Pricing & Integrations | Find Growth Tools
          </title>
          <meta
            name="description"
            content={`${name} overview: learn more about features, pricing, customers, integrations and more.`}
          />
          <meta
            property="og:image"
            content={`https:${screenshots[0].file.url}`}
          />
          <meta
            property="og:title"
            content={`${name} Features, Pricing & Integrations Overview | Find Growth Tools`}
          />
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:site" content="@findgrowthtools" />
          <meta
            name="twitter:title"
            content={`${name} Features, Pricing & Integrations Overview | Find Growth Tools`}
          />
          {/* <meta name="twitter:image" content={screenshots[0].file.url} /> */}
          <meta
            name="twitter:image"
            content={`https:${screenshots[0].file.url}`}
          />
        </Helmet>

        {/* <Button size="small"  onClick={this.props.history.goBack}>
          <Icon name="chevron left" />Back
        </Button> */}

        <Link style={{ color: '#dcddde' }} onClick={this.props.history.goBack}>
          <Icon name="chevron left" />Back
        </Link>

        <Segment raised style={{ minHeight: '665px' }}>
          <Grid stackable columns={2}>
            <Grid.Row>
              <Grid.Column width={9}>
                {/* <Segment basic> */}
                {primaryCategories.map(node => (
                  <Label
                    key={node.id}
                    basic
                    size="small"
                    style={{ marginBottom: '5px' }}
                    href={`/category/${node.slug}/`}
                  >
                    <Icon name="tag" />
                    {node.name}
                  </Label>
                ))}
                {subCategories ? (
                  subCategories.map(node => (
                    <Label
                      key={node.id}
                      basic
                      size="mini"
                      href={`/category/${node.primaryCategory.slug}/${
                        node.slug
                      }/`}
                    >
                      {node.name}
                    </Label>
                  ))
                ) : (
                  <span />
                )}

                  
                <h1
                  style={{
                    fontSize: '3.25rem',

                    color: '#39e7ce',  
                    // fontFamily: 'OpenSans-ExtraBold',
                    fontFamily: 'Open Sans',
                    fontWeight: '800',
                    letterSpacing: '-2.5px', }}


                >
                <OutboundLink href={website} target="_blank" style={{color: 'black',  }}>
                {name}
                      </OutboundLink>
                  
                </h1>
                <List>
                  <List.Item>
                    <List.Icon name="linkify" />
                    <List.Content>
                      <OutboundLink href={website} target="_blank">
                        {website}
                      </OutboundLink>
                    </List.Content>
                  </List.Item>
                </List>

                <List>
                  <List.Item>
                    <List.Icon name="rocket" />
                    <List.Content>
                      {growthLever ? (
                        growthLever.map(growthLever => (
                          <Label
                            basic
                            key={growthLever.id}
                            href={`/growthlever/${growthLever.slug}/`}
                            size="small"
                          >
                            {growthLever.name}{' '}
                          </Label>
                        ))
                      ) : (
                        <span />
                      )}{' '}
                    </List.Content>
                  </List.Item>
                </List>
                {/* </Segment> */}

                {/* <Segment basic> */}
                <Grid stackable columns={2}>
                  <Grid.Column>
                    <h4>Description</h4>
                    <div
                      dangerouslySetInnerHTML={{ __html: shortDescription }}
                      className="productcardText"
                    />
                  </Grid.Column>
                  <Grid.Column>
                    {ourView ? (
                      <div>
                        <h4>Comment</h4>
                        <div
                          dangerouslySetInnerHTML={{
                            __html: ourView.ourView,
                          }}
                          className="productcardText"
                        />
                      </div>
                    ) : (
                      <span />
                    )}
                  </Grid.Column>
                </Grid>
                {/* </Segment> */}
              </Grid.Column>
              <Grid.Column width={7}>
                <br />
                {/* <Image bordered src={screenshots[0].file.url} centered /> */}
                <div
                  style={{
                    borderStyle: 'solid',
                    borderWidth: '1px',
                    borderColor: '#d4d4d5',
                  }}
                >
                  <Img sizes={screenshots[0].sizes} />
                </div>
              </Grid.Column>
            </Grid.Row>
          </Grid>
          {/* New test section  */}

          <Grid stackable divided>
            <Grid.Row>
              <Grid.Column width={4}>
                <Segment basic>
                  <h4>Key features</h4>

                  {keyFeatures ? (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: keyFeatures.keyFeatures,
                      }}
                    />
                  ) : (
                    <span />
                  )}

                  {exampleUsecase ? (
                    <div>
                      <h4>Example usecase</h4>

                      {/* <em>{exampleUsecase.exampleUsecase}</em> */}
                      <div
                        dangerouslySetInnerHTML={{
                          __html: exampleUsecase.exampleUsecase,
                        }}
                      />
                    </div>
                  ) : (
                    <span />
                  )}
                </Segment>
              </Grid.Column>

              <Grid.Column width={4}>
                <Segment basic>
                  <h4>Pricing</h4>
                  <p style={{ fontSize: '1.2em' }}>
                    From <strong>${startingPrice}</strong> per month.
                  </p>

                  {pricingNote ? (
                    <div dangerouslySetInnerHTML={{ __html: pricingNote }} />
                  ) : (
                    <span />
                  )}

                  <h4>Free trials & plans</h4>
                  {freeTrialAvailable ? (
                    <Label
                      color="blue"
                      horizontal
                      style={{ marginBottom: '3px' }}
                    >
                      Free Trial available
                    </Label>
                  ) : (
                    <Label horizontal style={{ marginBottom: '3px' }}>
                      No Free Trial
                    </Label>
                  )}

                  {freePlan ? (
                    <Label
                      color="green"
                      horizontal
                      style={{ marginBottom: '3px' }}
                    >
                      Free Plan
                    </Label>
                  ) : (
                    <Label horizontal style={{ marginBottom: '3px' }}>
                      No Free Plan
                    </Label>
                  )}
                </Segment>
              </Grid.Column>

              <Grid.Column width={4}>
                <Segment basic>
                  <h4>Budget</h4>
                  {customerBudget ? (
                    customerBudget.map(node => (
                      <Label key={node.id} style={{ marginBottom: '3px' }}>
                        {node.name}{' '}
                      </Label>
                    ))
                  ) : (
                    <span />
                  )}

                  <h4>Target sectors</h4>
                  {customerSector ? (
                    customerSector.map(node => (
                      <Label key={node.id} style={{ marginBottom: '3px' }}>
                        {node.name}{' '}
                      </Label>
                    ))
                  ) : (
                    <span />
                  )}

                  <h4>Companies using {name}</h4>

                  {customersList ? (
                    customersList.map(node => (
                      <Label
                        key={node.id}
                        basic
                        style={{ marginBottom: '3px' }}
                        href={`/customer/${node.slug}/`}
                      >
                        {node.name}{' '}
                      </Label>
                    ))
                  ) : (
                    <span />
                  )}
                </Segment>
              </Grid.Column>

              <Grid.Column width={4}>
                <Segment basic>
                  <h4>Implementation</h4>
                  <div>
                    {developerRequired ? (
                      <Label
                        image
                        color="orange"
                        style={{ marginBottom: '3px' }}
                      >
                        Developer required
                      </Label>
                    ) : (
                      <Label
                        image
                        color="green"
                        style={{ marginBottom: '3px' }}
                      >
                        Simple setup
                      </Label>
                    )}
                    {apiAvailable ? (
                      <Label image color="blue" style={{ marginBottom: '5px' }}>
                        API availabile
                      </Label>
                    ) : (
                      <span />
                    )}
                  </div>
                  {setupNotes ? (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: setupNotes.setupNotes,
                      }}
                    />
                  ) : (
                    <span />
                  )}
                  {/* {apiAvailable ? (
                      <Label image color="blue" style={{ marginBottom: '5px', marginTop: '5px' }}>
                        API availabile
                      </Label>
                    ) : (
                      <span />
                    )} */}
                  <h4>Integrations</h4>

                  {integratesWithSegment ? (
                    <div>
                      <Label
                        image
                        basic
                        href={`/integration/segment/`}
                        style={{ marginBottom: '3px' }}
                      >
                        <img src={segmentLogo} />Integrates with Segment
                      </Label>
                    </div>
                  ) : (
                    <span />
                  )}
                  {integratesWithZapier ? (
                    <div>
                      <Label basic image style={{ marginBottom: '3px' }}>
                        <img src={zapierLogo} />Integrates with Zapier
                      </Label>
                    </div>
                  ) : (
                    <span />
                  )}

                  <div>
                    {integratesWith ? (
                      integratesWith.map(node => (
                        <Label
                          key={node.id}
                          basic
                          style={{ marginBottom: '3px' }}
                          href={`/integration/${node.slug}/`}
                        >
                          {node.name}
                        </Label>
                      ))
                    ) : (
                      <span />
                    )}
                  </div>
                </Segment>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row centered>
              <Grid.Column width={4}>
                <Segment basic>
                  <div style={{ textAlign: 'center' }}>
                    <h5>Social Profiles</h5>
                    {facebookLink ? (
                      <Button
                        circular
                        color="facebook"
                        href={facebookLink}
                        target="_blank"
                        icon="facebook"
                      />
                    ) : (
                      <span />
                    )}
                    {twitterLink ? (
                      <Button
                        circular
                        color="twitter"
                        href={twitterLink}
                        target="_blank"
                        icon="twitter"
                      />
                    ) : (
                      <span />
                    )}
                    {productHuntLink ? (
                      <Button
                        circular
                        color="google plus"
                        href={productHuntLink}
                        target="_blank"
                        icon="product hunt"
                      />
                    ) : (
                      <span />
                    )}
                    {youtubeLink ? (
                      <Button
                        circular
                        color="youtube"
                        href={youtubeLink}
                        target="_blank"
                        icon="youtube"
                      />
                    ) : (
                      <span />
                    )}
                  </div>
                </Segment>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Segment>
        <div style={{ textAlign: 'right' }}>
          {createdAt === updatedAt ? (
            <em>
              <small style={{ color: 'black' }}>Added: {createdAt}</small>
            </em>
          ) : (
            <em>
              <small style={{ color: 'black' }}>
                Last updated: {updatedAt}
              </small>
            </em>
          )}
        </div>
      </div>
    )
  }
}

ProductPage.propTypes = {
  data: PropTypes.object.isRequired,
}

export default ProductPage

export const pageQuery = graphql`
  query productPageQuery($slug: String!) {
    contentfulProduct(slug: { eq: $slug }) {
      id
      slug
      name
      website
      primaryCategories {
        id
        name
        slug
      }
      subCategories {
        id
        name
        slug
        primaryCategory {
          slug
        }
      }
      growthLever {
        id
        name
        slug
      }
      customerSector {
        id
        name
        slug
      }
      customerBudget {
        id
        name
        slug
      }
      integratesWith {
        id
        name
        slug
      }
      screenshots {
        id
        title
        sizes(maxWidth: 700) {
          ...GatsbyContentfulSizes
        }
        file {
          url
        }
      }
      shortDescription
      freeTrialAvailable
      freePlan
      integratesWithSegment
      integratesWithZapier
      developerRequired
      apiAvailable
      startingPrice
      pricingNote
      ourView {
        ourView
      }
      keyFeatures {
        keyFeatures
      }
      customersList {
        name
        id
        slug
      }
      exampleUsecase {
        exampleUsecase
      }
      setupNotes {
        setupNotes
      }
      facebookLink
      twitterLink
      productHuntLink
      youtubeLink
      createdAt(formatString: "MMMM Do, YYYY")
      updatedAt(formatString: "MMMM Do, YYYY")
    }
  }
`



// WEBPACK FOOTER //
// ./src/templates/product-page.js